/**
 * @file Constant.js
 * @desc 常量，包含接口路径，独立页面内公共常量
 * @author ~~
 * @data 2019/01/07
 */

const Const = {};
// 开发机环境
if (process.env.NODE_ENV === 'development') {
    Const.server = '';
    Const.baseUrl = 'http://gzdt-sys-rpm68avpxvd.gzdt.baidu.com:8983';
}
// QA环境
else if (process.env.NODE_ENV === 'test') {
    // Const.server = 'http://cp01-maptest01.epc.baidu.com:8080/treasure/';
    Const.server = '';
    Const.baseUrl = 'https://newclient.map.baidu.com/feed-h5';
}
// 线上环境
else {
    Const.server = '';
    Const.baseUrl = 'https://newclient.map.baidu.com/feed-h5';
}

// 是否登陆接口
Const.checkLogin = 'login';

Const.dataUrl = {
    checkLogin: Const.server + Const.checkLogin
};

// 域名信息
Const.hostname = location.hostname || 'newclient.map.baidu.com';

// 客户端信息
Const.nativeInfo = {};

export default Const;
